export default "__VITE_ASSET__C9NYQE4L__"